<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Exclude Seller</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Exclude Seller</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="la la-tree"></i> Add Seller
                </a>
                <a
                  v-show="false"
                  ref="formBcEdit"
                  class="btn add-btn"
                  @click="showBroadcast(false)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-tags"></i> Edit
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row" style="margin-bottom: 20px;">
            <div class="col-md-12">
              <div class="row filter-row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-4">Brand</label>
                    <div class="col-md-8">
                      <multiselect
                        v-model="selectedContact"
                        id="ajax"
                        label="name"
                        track-by="id"
                        :placeholder="'Type to search Brand...'"
                        :multiple="true"
                        open-direction="bottom"
                        :custom-label="customLabel"
                        :options="contactOptions"
                        :searchable="true"
                        :loading="isLoading"
                        :internal-search="false"
                        :close-on-select="false"
                        :options-limit="300"
                        :limit="3"
                        :limit-text="limitText"
                        :max-height="600"
                        :show-no-results="true"
                        :hide-selected="true"
                        @search-change="asyncFind"
                        :show-labels="false"
                      >
                        <template slot="tag" slot-scope="{ option, remove }">
                          <span class="custom__tag">
                            <span>{{ option.name }}</span>
                            <span class="custom__remove" @click="remove(option)"
                              >❌</span
                            >
                          </span>
                        </template>
                        <template slot="clear" slot-scope="props">
                          <div
                            class="multiselect__clear"
                            v-if="selectedContact.length"
                            @mousedown.prevent.stop="clearAll(props.search)"
                          ></div>
                        </template>
                        <span slot="noResult">Oops! No elements found.</span>
                      </multiselect>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-4">Marketplace</label>
                    <div class="col-md-8">
                      <select
                        v-model="serverParams.columnFilters.mp_id"
                        class="form-control"
                      >
                        <option :value="''">All</option>
                        <template v-if="dataListMarketplace.length">
                          <option
                            :value="marketplace"
                            v-for="(marketplace, idx) in dataListMarketplace"
                            :key="idx"
                            >{{ marketplace | capitalising }}</option
                          >
                        </template>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row filter-row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      v-model="serverParams.columnFilters.store_name"
                      type="text"
                      placeholder="Username Toko"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="searchData"
                    class="btn btn-success btn-block"
                    >Search</a
                  >
                </div>
                <div class="col-md-3">
                  <a
                    href="javascript:void(0)"
                    @click.prevent="clearForm"
                    class="btn btn-danger btn-block"
                    >Reset</a
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <!-- <th>#</th> -->
                      <th>Brand</th>
                      <th class="text-center">Marketplace</th>
                      <th>Username Toko</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="4">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <!-- <td>{{row.number}}</td> -->
                        <td class="text-wrap" :ref="'id-' + row.id">
                          <Skeleton :count="1" />
                        </td>
                        <td class="text-center text-wrap">
                          <div v-html="marketplaceIcon(row.mp_id)"></div>
                          <i
                            style="margin-top: 8px;"
                            v-if="row.is_bookmark == 1"
                            class="la la-bookmark"
                          ></i>
                        </td>
                        <td class="text-left">
                          <a
                            :href="row.store_link"
                            target="_blank"
                            v-if="row.store_name != ''"
                            >{{ row.store_name }}</a
                          >
                        </td>
                        <td>
                          <div class="dropdown action-label">
                            <a
                              class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                              href="#"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i>
                              Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a
                                @click.prevent="detailData(row.id)"
                                class="dropdown-item"
                              >
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>
                              <a
                                @click.prevent="deleteData(row.id)"
                                class="dropdown-item"
                              >
                                <i class="fa fa-trash text-danger"></i> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="4" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchData" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";
import { marketplaceIcon } from "@/utils/helper";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    Multiselect
  },
  data() {
    return {
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      dataListMarketplace: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          brand_id: "",
          mp_id: "",
          store_name: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.brand_id = val[0].id;
        } else {
          this.serverParams.columnFilters.brand_id = "";
        }
      },
      deep: true
    }
  },
  created() {
    this.asyncFind("");
    this.getMarketplaceList();
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    getMarketplaceList() {
      this.$store.dispatch("monitoring/getMarketplaceList").then(respons => {
        this.dataListMarketplace = respons.data;
      });
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    clearForm() {
      this.serverParams.columnFilters.brand_id = "";
      this.serverParams.columnFilters.mp_id = "";
      this.serverParams.columnFilters.store_name = "";
      this.clearAll();
      this.searchData();
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("store/setIsShowForm", false);

      let formData = await {};
      await this.$store
        .dispatch("store/list", { columnFilters: { id } }) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData = data.data[0];
        });
      console.log("formData::", formData);
      formData.id = id;
      await this.$store.dispatch("store/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    deleteData(id) {
      this.$fire({
        title: "Anda yakin ingin menghapus seller ini?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            this.$store
              .dispatch("store/deleteData", { id })
              .then(_ => {
                this.$fire({
                  title: "Berhasil Dihapus",
                  text: "Seller berhasil dihapus.",
                  type: "success",
                  timer: 2000
                });
                this.loadItems();
              })
              .catch(_ => {
                return;
              });
          } else {
            return;
          }
        })
        .catch(_ => {
          return;
        });
    },

    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("store/setIsShowForm", false);

        let formData = {
          id: "",
          brand_id: "",
          mp_id: "",
          store_name: "",
          store_link: ""
        };
        this.$store.dispatch("store/actFormParamSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("store/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("store/list", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let detailId = row.brand_id;
              this.$store
                .dispatch("brand/detail", detailId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["id-" + row.id][0].innerHTML = resData.name;
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/store/list.vue